import {
  assignToListIcon,
  assignToListIconRed,
  InfluencerRating,
} from "../../Components";
import { utils } from "../../Helpers";
import { useNavigate } from "react-router-dom";
import { storageHandler } from "../../Helpers";
export default function CardInfluencerSearch(props) {
  const navigate = useNavigate();

  let userData = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      userData = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }

  const chkLoginandActionAccordingly = (event, influencer) => {
    event.stopPropagation();
    if (props.isUserHasSubscription && userData.p_f_ids.includes(1)) {
      if (props.profiles !== undefined) {
        if (props.isUserHasSubscription === true) {
          props.setSelectedInfluencer(influencer);
          props.setModal("addtoList");
        } else {
          props.setIsUserHasAccessListing(false);
        }
      } else {
        navigate("/account/pricing");
      }
    } else {
      props.setIsSubscribeModal(true);
    }
  };
  const getStringOfBio = (influencer) => {
    return influencer.bio
      ? influencer.bio !== ""
        ? utils.testJSON(influencer.bio)
          ? utils.draftJsFormatingForDetailsBio({
              data: influencer.bio,
              view: "lessview",
            })
          : influencer.bio.substring(0, 25)
        : ""
      : "";
  };
  const confirmRemoveFromList = async (event, influencer) => {
    event.stopPropagation();
    props.setSelectedInfluencer(influencer);
    props.setModal("confirmDelete");
  };

  const showInfProfile = async (influencer) => {
    if (props.isUserHasSubscription && userData.p_f_ids.includes(1)) {
      storageHandler.setUserTypeForProfileItem(JSON.stringify(influencer.type));
      navigate("/brand/influencerProfile/" + influencer.id);
    } else {
      props.setIsSubscribeModal(true);
    }
  };

  const userDisplayFormat = (count) => {
    if (count >= 1000000000)
      return (count / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";

    if (count >= 1000000)
      return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";

    if (count >= 1000)
      return (count / 1000).toFixed(1).replace(/\.0$/, "") + "K";

    return count;
  };
  return (
    <>
      <div
        className="cardMain"
        onClick={() => showInfProfile(props.influencer)}
      >
        <div className="top-icons">
          <div className="social-icons flex gap-1 border border-gray-50 bg-gray-100 rounded-full px-3 py-0.5">
            {props.influencer.social_platforms.IG && (
              <img
                src="images/instagram.svg"
                width="28"
                title="instagram"
                alt="instagram"
              />
            )}
            {props.influencer.social_platforms.FB && (
              <img
                src="images/facebook.svg"
                width="28"
                title="facebook"
                alt="facebook"
              />
            )}
            {props.influencer.social_platforms.YT && (
              <img
                src="images/youtube.svg"
                width="28"
                title="youtube"
                alt="youtube"
              />
            )}
            {props.influencer.social_platforms.TT && (
              <img
                src="images/tiktok-logo.svg"
                width="26"
                title="tiktok"
                alt="tiktok"
              />
            )}
            <span className="text-start text-gray-500 mt-1">
              {userDisplayFormat(
                props.influencer.social_accounts?.[props.influencer.social_accounts.length - 1]?.followers || ""
              )}
            </span>
          </div>
          <div className="flex gap-3">
            {props.profiles === undefined ? (
              <div
                className="like-icon"
                onClick={(e) =>
                  chkLoginandActionAccordingly(e, props.influencer)
                }
              >
                {assignToListIcon}
              </div>
            ) : props.influencer.list_id !== "" ? (
              <div
                class="like-icon"
                onClick={(e) => confirmRemoveFromList(e, props.influencer)}
              >
                {assignToListIconRed}
              </div>
            ) : (
              <div
                class="like-icon"
                onClick={(e) =>
                  chkLoginandActionAccordingly(e, props.influencer)
                }
              >
                {assignToListIcon}
              </div>
            )}
          </div>
        </div>
        <div
          className="image-wrapper"
          style={{
            backgroundImage:
              props.influencer.profile_img_url === ""
                ? `url( ${process.env.PUBLIC_URL}/images/placeholder/avatar.png)`
                : `url(${props.influencer.profile_img_url})`,
          }}
        ></div>
        <div className="rating">
          <div className="star-container " data-rating="0">
            <InfluencerRating
              infrating={props.influencer.rating}
            ></InfluencerRating>
          </div>
        </div>
        <div className="username">{props.influencer.display_name}</div>
        {props.influencer.bio && props.influencer.bio !== "" && (
          <div className="tags">
            <p className="tagstext">
              {props.influencer.bio
                ? getStringOfBio(props.influencer) !== ""
                  ? getStringOfBio(props.influencer)
                  : ""
                : ""}
            </p>
          </div>
        )}
      </div>
    </>
  );
}
